import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 shadow-2xl">
          <h1 className="text-3xl font-bold text-white mb-8">Privacy Policy</h1>
          
          <div className="text-gray-300 space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Information We Collect</h2>
              <p>
                Vaulto connects to your Instagram and Google Drive accounts to backup your Instagram content. 
                We only access the content you explicitly authorize us to backup.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">How We Use Your Information</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>To backup your Instagram posts, reels, and stories to your Google Drive</li>
                <li>To provide you with backup statistics and progress updates</li>
                <li>To ensure the security and proper functioning of our service</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Data Storage</h2>
              <p>
                Your Instagram content is backed up directly to your personal Google Drive account. 
                We do not store your content on our servers permanently.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Data Sharing</h2>
              <p>
                We do not sell, trade, or share your personal information with third parties. 
                Your data is only used for the backup services you have requested.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Account Disconnection</h2>
              <p>
                You can disconnect your Instagram and Google Drive accounts at any time through your account settings. 
                Upon disconnection, we will stop accessing your accounts immediately.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-3">Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy, please contact us at privacy@vaulto.app
              </p>
            </section>

            <section className="text-sm text-gray-400 mt-8 pt-4 border-t border-white/20">
              <p>Last updated: {new Date().toLocaleDateString()}</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy; 